import React from 'react';

import { SupportedCurrency } from '../../../../../domain/currency';

const CONFIG: {
    [key in SupportedCurrency]: {
        label: string;
        id: string;
        value: string;
    }
} = {
    EUR: {
        label: 'EUR',
        id: 'currencyEUR',
        value: 'EUR',
    },
    PLN: {
        label: 'PLN',
        id: 'currencyPLN',
        value: 'PLN',
    },
};

export const CurrencySelector = ({ selectedCurrency, setSelectedCurrency }: {
    selectedCurrency: SupportedCurrency,
    setSelectedCurrency: (newCurrency: SupportedCurrency) => void
}) =>
    <div className="btn-group ms-auto" role="group">
        {Object.values(CONFIG).map(({ label, id, value }) => (
            <>
                <input
                    type="radio"
                    className="btn-check"
                    name="currency"
                    id={id}
                    value={value}
                    checked={selectedCurrency === value}
                    onChange={(e) => setSelectedCurrency(e.target.value as SupportedCurrency)}
                />
                <label className="btn btn-outline-primary" htmlFor={id}>{label}</label>
            </>
        ))}
    </div>;
